module.exports = __webpack_public_path__ + "static/media/dg_white.42c3a245.png";